import { api, ApiRequestConfig } from './api';
import { DeliveryStoreIdsParams, DeliveryStoreIdsResponse } from 'types/delivery-store-ids';

export const getDeliveryStoreIds = (
  { latitude, longitude }: DeliveryStoreIdsParams,
  config: ApiRequestConfig,
) =>
  api.get<DeliveryStoreIdsResponse>(
    'delivery-store-ids',
    { latitude: String(latitude), longitude: String(longitude) },
    config,
  );
